import type { ContentTypeObject, CustomHtmlElement } from '../../types/pbTypes';
import type { PbTabs } from '../../types/pbBlocks';
import {
    parseStyleString,
    getTabNavigationAlignment,
    getBorder,
    getCssClasses,
    getMargin,
    getPadding,
    getTextAlign,
    getIsHidden,
} from '../utils';

export type TabsType = ContentTypeObject & PbTabs;

/**
 * Aggregates the configuration of a tabs element.
 * @param node
 */
export function tabsConfigAggregator(node: CustomHtmlElement): TabsType {
    const navigationEl = node.childNodes[0] as CustomHtmlElement;
    const content = node.childNodes[1] as CustomHtmlElement;

    const headerEls = navigationEl.childNodes;
    const headers = Array.from(headerEls, (headerEl) => headerEl.textContent);

    const style = parseStyleString(node.attributes.style);
    const contentStyle = parseStyleString(content.attributes.style);

    return {
        ...getMargin(style),
        ...getPadding(style),
        ...getCssClasses(node),
        ...getBorder(contentStyle),
        ...getTextAlign(contentStyle),
        ...getIsHidden(style),
        headers,
        defaultIndex: node.attributes['data-active-tab'] ? parseInt(node.attributes['data-active-tab'], 10) : 0,
        minHeight: contentStyle?.minHeight,
        tabNavigationAlignment: getTabNavigationAlignment(node.attributes['class']),
        uniqueID: node.attributes['data-pb-style'],
    };
}
